import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { MixpanelManager } from '../../Mixpanel/mixpanelManager'
import { File } from '../../models/Organization'
import { calculateAge } from '../../utils/Common'
import { createSelector } from '@reduxjs/toolkit'
import { updateSelectedFile } from '../../actions/organization'
import { setShowProgressModal } from '../../actions/construction'

const THUMBNAILS_URL = process.env.REACT_APP_THUMBNAILS_URL

const projectsSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.projects,
)

const RecentFile = (props: { fileInfo: File }) => {
  const { fileInfo } = props
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const projects = useSelector(projectsSelector)
  const project = projects.find((project) => project.id === fileInfo.project_id)

  const handleClick = () => {
    if (!fileInfo.path) return

    MixpanelManager.track('Recent File Click', {
      fileId: fileInfo.id,
      fileName: fileInfo.name,
    })

    dispatch(updateSelectedFile(fileInfo))
    navigate(`/projects/${project?.id}/files`, {
      state: { from: 'recentFile' },
    })
  }

  return (
    <Button
      onClick={handleClick}
      sx={{
        display: 'flex',
        gap: '0.5rem',
        flexDirection: 'column',
        textTransform: 'none',
        p: 0,
        width: '100%',
        textAlign: 'left',
      }}
    >
      <Box
        component='img'
        src={`${THUMBNAILS_URL}/thumbnails/${fileInfo.thumbnail_path}`}
        alt='Project Thumbnail'
        onError={({ currentTarget }) => {
          currentTarget.onerror = null
          currentTarget.src = '/images/file-thumbnail.png'
        }}
        sx={{
          borderRadius: '4px',
          border: '0.5px solid #B5B5B5',
          height: '10rem',
          width: '100%',
        }}
      ></Box>
      <Box width='100%' display='flex' flexDirection='column'>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.76rem',

              color: '#04002E',
            }}
          >
            {fileInfo?.name}
          </Typography>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.58rem',

              color: '#04002E',
            }}
          >
            {calculateAge(fileInfo.updatedAt ?? Date.now().toString())}
          </Typography>
        </Box>
        <Box width='100%' display='flex'>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.64rem',

              color: '#878787',
            }}
          >
            {project?.name}
          </Typography>
        </Box>
      </Box>
    </Button>
  )
}

export default RecentFile
